import React, { useState, useEffect, useRef } from "react";
import tw from "tailwind-styled-components";
import Images from "../../Images";
//import Images from "../../../Images";

const MAX_FILES = 5;
const MAX_FILE_SIZE = 5 * 1024 * 1024;

const ACCEPTED_TYPES = [
    "image/png",
    "image/jpeg",
    "image/jpg",
    "image/webp",
    "image/gif",
    "image/bmp",
    "application/pdf",
];

const DropZone = ({
    setFieldValue,
    componentFor,
    setUploadFile,
    File,
    existingImageUrl,
}) => {
    const [files, setFiles] = useState(File || []);
    const [error, setError] = useState("");

    const inputRef = useRef(null);

    useEffect(() => {
        return () => {
            files.forEach(file => {
                if (file.preview) {
                    URL.revokeObjectURL(file.preview);
                }
            });
        };
    }, []);

    useEffect(() => {
        if (componentFor === "profile") {
            setFieldValue("media", files);
        } else if (componentFor === "expense") {
            setFieldValue("file", files);
        } else if (componentFor === "admin") {
            setUploadFile(files);
        }
    }, [files]);

    const validateFile = (file) => {
        if (!ACCEPTED_TYPES.includes(file.type)) {
            return "Only Images and PDF files are allowed.";
        }

        if (file.size > MAX_FILE_SIZE) {
            return `${file.name} exceeds 5 MB.`;
        }

        return null;
    };

    const handleFileSelect = (e) => {
        const selectedFiles = Array.from(e.target.files);

        if (!selectedFiles.length) return;

        setError("");

        let updatedFiles = [...files];

        for (const file of selectedFiles) {

            const validation = validateFile(file);

            if (validation) {
                setError(validation);
                continue;
            }

            const alreadyExists = updatedFiles.some(
                item =>
                    item.name === file.name &&
                    item.size === file.size
            );

            if (alreadyExists) {
                continue;
            }

            if (updatedFiles.length >= MAX_FILES) {
                setError(`Maximum ${MAX_FILES} files allowed.`);
                break;
            }

            const fileWithPreview = Object.assign(file, {
                preview:
                    file.type === "application/pdf"
                        ? null
                        : URL.createObjectURL(file),
            });

            updatedFiles.push(fileWithPreview);
        }

        setFiles(updatedFiles);

        e.target.value = "";
    };

    const removeFile = (index) => {

        const temp = [...files];

        if (temp[index]?.preview) {
            URL.revokeObjectURL(temp[index].preview);
        }

        temp.splice(index, 1);

        setFiles(temp);
    };

    return (
        <div className="w-full">

            {/* <input
                ref={inputRef}
                type="file"
                multiple
                accept="image/*,.pdf"
                hidden
                onChange={handleFileSelect}
            /> */}

            <div className="w-full">
                <input
                    ref={inputRef}
                    type="file"
                    multiple
                    accept="image/*,.pdf"
                    hidden
                    onChange={handleFileSelect}
                />

                {/* <div className="flex gap-4 overflow-x-auto p-3"> */}
                <div className="flex flex-wrap gap-4 p-3">

                    {files.map((file, index) => {
                        const isPdf = file.type === "application/pdf";

                        return (
                            <div
                                key={`${file.name}-${index}`}
                                className="relative shrink-0 w-28"
                            >
                                <button
                                    type="button"
                                    onClick={() => removeFile(index)}
                                    className="absolute -top-2 -right-2 z-20 w-6 h-6 rounded-full bg-red-500 text-white text-xs flex items-center justify-center shadow"
                                >
                                    ✕
                                </button>

                                <div className="w-28 h-28 rounded-xl border border-gray-200 overflow-hidden bg-gray-50">

                                    {isPdf ? (
                                        <div className="w-full h-full flex flex-col items-center justify-center">
                                            <span className="text-4xl">📄</span>
                                        </div>
                                    ) : (
                                        <img
                                            src={file.preview}
                                            alt={file.name}
                                            className="w-full h-full object-cover"
                                        />
                                    )}

                                </div>

                                <p
                                    className="mt-2 text-xs text-center truncate"
                                    title={file.name}
                                >
                                    {file.name}
                                </p>
                            </div>
                        );
                    })}

                    {files.length < MAX_FILES && (
                        <button
                            type="button"
                            onClick={() => inputRef.current.click()}
                            className="shrink-0 w-28 h-28 rounded-xl border-2 border-dashed border-gray-300 bg-gray-50 hover:bg-gray-100 flex flex-col items-center justify-center transition"
                        >
                            <span className="text-4xl text-primary-color">+</span>

                            <span className="text-xs text-gray-500 mt-1">
                                Add File
                            </span>
                        </button>
                    )}

                </div>

                {error && (
                    <p className="mt-3 text-sm text-red-500">
                        {error}
                    </p>
                )}

                <div className="mt-0 text-xs text-gray-500">
                    {files.length}/{MAX_FILES} files selected
                </div>
            </div>

            {error && (
                <div className="mt-3 text-sm text-red-500">
                    {error}
                </div>
            )}
        </div >
    );
};

const FieldWrapper = tw.div`
    w-full
`;

export default DropZone;